import React from 'react';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const StepFour = ({ currentTheme, themeMode }) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 200px)',
      textAlign: 'center',
      px: 4
    }}>
      {/* Success Icon */}
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: themeMode === 'dark' ? 'rgba(255, 112, 82, 0.2)' : '#FFF0ED',
          border: `2px solid ${currentTheme.common.danger}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3
        }}
      >
        <CheckCircleIcon
          sx={{
            fontSize: 50,
            color: currentTheme.common.danger
          }}
        />
      </Box>

      {/* Success Heading */}
      <Typography
        variant="h4"
        component="h1"
        fontWeight="bold"
        sx={{
          mb: 2,
          color: themeMode === 'dark' ? currentTheme.text.primary : "#333333",
          fontSize: '28px'
        }}
      >
        Purchase Successful
      </Typography>

      {/* Success Message */}
      <Typography
        variant="body1"
        sx={{
          mb: 4,
          color: themeMode === 'dark' ? currentTheme.text.secondary : "#666666",
          fontSize: '16px',
          maxWidth: '500px'
        }}
      >
        Your fax number has been successfully assigned to the selected facility and departments. You can now start using it.
      </Typography>

      {/* Return to Dashboard Button */}
      <Button
        variant="contained"
        sx={{
          backgroundColor: currentTheme.common.danger,
          '&:hover': { backgroundColor: '#E54B36' },
          textTransform: 'none',
          borderRadius: '8px',
          px: 4,
          py: 1.5,
          color: 'white',
          fontWeight: 'normal',
          fontSize: '14px',
        }}
        onClick={() => {
          // Navigate back to dashboard or close modal
          window.history.back();
        }}
      >
        Return to Dashboard
      </Button>
    </Box>
  );
};

export default StepFour;
